import { render, staticRenderFns } from "./update-charge.vue?vue&type=template&id=185bc786&scoped=true"
import script from "./update-charge.vue?vue&type=script&lang=js"
export * from "./update-charge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185bc786",
  null
  
)

export default component.exports